/**
 * Gestiona la sesión del módulo ciudadano "Mi Ecoparque".
 * No sustituye al AuthContext general; sólo guarda el user_code validado.
 */
const STORAGE_KEY = 'ecoparque_session_v1';

export function saveEcoparqueSession(user) {
  try {
    const payload = {
      user_code: user.user_code,
      nombre: user.nombre,
      email: user.email,
      qr_data: user.qr_data,
      created_at: user.created_at,
      saved_at: new Date().toISOString(),
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    return payload;
  } catch (e) {
    console.error('No se pudo guardar la sesión Ecoparque', e);
    return null;
  }
}

export function getEcoparqueSession() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function clearEcoparqueSession() {
  localStorage.removeItem(STORAGE_KEY);
}
